module.exports = OpenSeadragon;